module.exports = __webpack_public_path__ + "media/images/dummy_item15-c3d55ceca532ed262a76a6f08502e96b.jpg";